import { Button, Col, Form, FormProps, Input, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react'
import { IoIosSend } from 'react-icons/io';
import GoogleMaps from '../../components/google_maps';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitData } from './request';
import { Notification } from '../../utils/notification';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

type FieldType = {
  fullName?: string;
  email?: string;
  message?: string;
  phone?: string;
};

const Contact: React.FC = () => {
  const {t} = useTranslation()
  const [form] = Form.useForm()
  const queryClient = useQueryClient();

  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const { mutate } = useMutation({
    mutationFn: (newVals) => submitData(undefined, newVals),
    onSuccess: async (res) => {
      queryClient.setQueryData(["feedback"], res);
      Notification("success",  "create", res?.message)
      form.resetFields()
    },
    onError: (error: AxiosError) => {
      Notification(`error`, "create", error?.name)
    },
    retry: 0,
  });

  return (
    <div>
      {/* <h2 className='text-[22px] font-bold text-main_color'>{t('Contact us')}</h2> */}
      <div className='grid grid-cols-12 gap-6 mt-6'>
        <div className="xl:col-span-8 lg:col-span-12 md:col-span-8 col-span-12">
          <Form
            form={form}
            name="basic"
            onFinish={(values: any) => mutate(values)}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Row className='max-sm:hidden' gutter={[24, 24]}>
              <Col span={12}>
                <Form.Item<FieldType> name={'fullName'}>
                  <Input placeholder='fullname' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
                <Form.Item<FieldType> name={'email'}>
                  <Input placeholder='email' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
                <Form.Item<FieldType> name={'phone'}>
                  <Input placeholder='phone' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item<FieldType> name={'message'}>
                  <TextArea placeholder='Message' className='rounded-xl bg-[#EDEDED] text-[#29487E] w-full' rows={5}></TextArea>
                </Form.Item>
                <Form.Item>
                  <Button htmlType='submit' className='w-full text-center justify-center text-white rounded-xl bg-[#1C70A3] flex items-center text-[18px] font-semibold h-[47px]'><IoIosSend size={20} className='mr-4' />{t("Send message")}</Button>
                </Form.Item>
              </Col>
            </Row>
            <Row className='sm:hidden' gutter={[24, 24]}>
              <Col span={24}>
                <Form.Item<FieldType> name={'fullName'}>
                  <Input placeholder='fullname' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
                <Form.Item<FieldType> name={'email'}>
                  <Input placeholder='email' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
                <Form.Item<FieldType> name={'phone'}>
                  <Input placeholder='phone' className='rounded-xl h-[47px] bg-[#EDEDED] text-[#29487E] w-full' />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item<FieldType> name={'message'}>
                  <TextArea placeholder='Message' className='rounded-xl bg-[#EDEDED] text-[#29487E] w-full' rows={5}></TextArea>
                </Form.Item>
                <Form.Item>
                  <Button htmlType='submit' className='w-full text-center justify-center text-white rounded-xl bg-[#1C70A3] flex items-center text-[18px] font-semibold h-[47px]'><IoIosSend size={20} className='mr-4' />{t("Send message")}</Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="xl:col-span-4 lg:col-span-12 md:col-span-4 col-span-12">
          <div className='flex justify-between'>
            <div className='w-[45%]'>
              <div>
                <p className='my-3'>{t("Email")}</p>
                <a href='mailto:info@udrc.uz' className='font-semibold'>info@udrc.uz</a>
              </div>
              <div>
                <p className='my-3'>{t("Phone")}</p>
                <p className='font-semibold'>+998 55 520 60 50</p>
              </div>
            </div>
            <div className='w-[45%]'>
              <p className='my-3'>{t("Address")}</p>
              <p className='font-semibold'>{t("21 Bobur Street, Yakkasaray District, Tashkent city")}</p>
            </div>
          </div>
        </div>
      </div>
      <hr className='w-full rounded bg-[#29487E] h-[2px] my-6' />
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <GoogleMaps  />
        </div>
      </div>
    </div>
  )
}

export default Contact